<template>
  <div style="width: 100%;height:100%;">
    <div class="mobileBox" v-show="isShowMobile">
      <a class="close el-icon-close" @click="close" title="关闭"></a>
      <div class="mobileCon">
        <div class="mobileHeader">
          <i class="l-icon"></i>
        </div>
        <div class="mobileMain">
          <div class="mobileMainHeader"><img src="@/assets/images/mobile-header.png"></div>
          <div class="mobileMainBox">
            <div style="padding:50px 10px 10px 10px;">
              <div class="mobileTit" v-if="mobileTit">{{mobileTit}}</div>
              <img :src="mobileImage" class="mobile-image">
            </div>
          </div>
        </div>
        <div class="mobileFooter">
          <i class="c-icon"></i>
        </div>
      </div>
    </div>
      <div class="mobileBox" v-show="isShowMobileA">
          <a class="close el-icon-close" @click="close" title="关闭"></a>
          <div class="mobileCon">
              <div class="mobileHeader">
                  <i class="l-icon"></i>
              </div>
              <div class="mobileMain">
                  <div class="mobileMainHeader"><img src="@/assets/images/mobile-header.png"></div>
                  <div class="mobileMainBox">
                      <div style="padding:50px 10px 10px 10px;">
                          <div class="mobileTit" v-if="mobileTit">{{mobileTit}}</div>
                          <div class="ql-container ql-snow" style="border:none;">
                              <div class="ql-editor">
                                  <div v-html="mobileCon"></div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="mobileFooter">
                  <i class="c-icon"></i>
              </div>
          </div>
      </div>
    <el-dialog
            title="客服咨询"
            :visible.sync="dialogService"
            width="400px">
      <div class="codeList">
        <ul class="flex justify-content">
          <li class="item">
            <p class="img"><img src="@/assets/images/code-qy.jpg"></p>
            <p>企业助手</p>
          </li>
        </ul>
      </div>
    </el-dialog>
    <manage-header :ep_name="ep_name" :enterprise_logo="enterprise_logo"></manage-header>
    <div class="main">
      <div class="sidebar">
          <div class="user-information">
              <img :src="enterprise_logo" v-if="enterprise_logo" class="logo">
              <img src="@/assets/images/default-head.jpg" v-if="!enterprise_logo" class="logo">
              <p class="name">{{ep_name}}</p>
              <p class="tips">会员卡有效期：{{member_end_time | formatDate}}</p>
              <div class="margin-top-20 flex justify-content">
                  <el-tag class="member-tags" v-if="this.$store.state.is_operater === 0 && this.$store.state.rank === 1">青铜会员</el-tag>
                  <el-tag class="member-tags" v-if="this.$store.state.is_operater === 0 && this.$store.state.rank === 2">黄金会员</el-tag>
                  <el-tag class="member-tags" v-if="this.$store.state.is_operater === 0 && this.$store.state.rank === 3">钻石会员</el-tag>
                  <el-tag class="member-tags" v-if="this.$store.state.is_operater === 1 && this.$store.state.rank === 1">运营账号</el-tag>
                  <el-tag class="member-tags" type="success">认证商家</el-tag>
              </div>
          </div>
          <div class="my-balance">
              <div class="flex align-items">
                  <img src="@/assets/images/manage-left-icon-0.png" class="icon">
                  <span class="text">我的余额</span>
                  <span class="recharge"><router-link to="/enterprise/balance"><i>明细</i></router-link><router-link to="/enterprise/recharge"><i>充值</i></router-link></span>
              </div>
              <div class="flex align-items money-box margin-top-20">
                  <span class="money" v-if="showMoney === true">{{money}}<i v-if="!money">0.00</i></span>
                  <span class="money" v-if="showMoney === false">******</span>
                  <span class="icon" @click="showMoneyClick" v-if="showMoney === true"><img src="@/assets/images/manage-left-money-view-icon.png"></span>
                  <span class="icon" @click="showMoneyClick" v-if="showMoney === false"><img src="@/assets/images/manage-left-money-view-icon-1.png"></span>
              </div>
          </div>
        <div class="left-nav-list">
          <ul>
            <router-link to="/enterprise/manage" tag="li" class="item flex align-items"><span class="icon"><img src="@/assets/images/manage-left-icon-1.png"></span><span class="text">管理首页</span></router-link>
            <router-link to="/enterprise/info" tag="li" class="item flex align-items"><span class="icon"><img src="@/assets/images/manage-left-icon-2.png"></span><span class="text">企业信息</span></router-link>
            <router-link to="/enterprise/order" tag="li" class="item flex align-items"><span class="icon"><img src="@/assets/images/manage-left-icon-3.png"></span><span class="text">我的推广</span></router-link>
            <router-link to="/enterprise/reward" tag="li" class="item flex align-items" v-if="this.$store.state.rank > 1"><span class="icon"><img src="@/assets/images/manage-left-icon-6.png"></span><span class="text">奖励管理</span></router-link>
<!--            <router-link to="/enterprise/balance" tag="li" class="item flex align-items"><span class="icon"><img src="@/assets/images/manage-left-icon-4.png"></span><span class="text">我的余额</span></router-link>-->
            <router-link to="/enterprise/account" tag="li" class="item flex align-items" v-if="this.$store.state.is_operater === 0 && this.$store.state.rank !== 0"><span class="icon"><img src="@/assets/images/manage-left-icon-4.png"></span><span class="text">运营账号</span></router-link>
<!--            <router-link to="/enterprise/message" tag="li" class="item clearfix"><i class="icon el-icon-chat-line-round fl"></i><span class="text fl">消息中心</span><span class="dot" v-if="is_new === 1"></span></router-link>-->
            <router-link to="/enterprise/use" tag="li" class="item flex align-items"><span class="icon"><img src="@/assets/images/manage-left-icon-5.png"></span><span class="text fl">使用指南</span></router-link>
          </ul>
        </div>
      </div>
      <div class="manage-main">
        <transition name="el-fade-in">
          <router-view></router-view>
        </transition>
<!--        <div class="manage-footer">{{this.$store.state.siteName}}-企业同城推广好帮手 个人流量变现神器</div>-->
      </div>
        <back-top></back-top>
    </div>
  </div>
</template>
<script>
import {epInfo,newsData} from '@/config/api.js'
import ManageHeader from '@/components/ManageHeader'
import {formatDate} from '../../utils/formatDate.js'
import BackTop from '@/components/BackTop'
export default {
  name: 'Enterprise',
  data () {
    return {
      ep_name: '',
      enterprise_logo: '',
      member_end_time: '',
      dialogService:false,
      is_new:null,
      is_official: '',
      money:null,
      isShowMobile: false,
      isShowMobileA: false,
      mobileCon:'',
      mobileTit:'',
      mobileImage:'',
      propagandaTitle: '',
      showMoney:false
    }
  },
  provide(){
    return{
      showMobile:this.showMobile,
      showMobileA:this.showMobileA
    }
  },
  components: {
    ManageHeader,
      BackTop
  },
  methods: {
    getEpInfo () {
      let data = {
        ep_id:this.$store.state.user_id,
      };
      this.$post(epInfo, data)
              .then(res => {
                let data = res.data;
                this.ep_name = data.name;
                this.enterprise_logo = data.enterprise_logo;
                this.is_auth = data.is_auth;
                this.money = data.money;
                this.member_end_time = data.member_end_time;
                this.is_official = Number(data.is_official);
                this.$store.commit('changeIsOfficial',this.is_official);
              })
              .catch(err => {
                window.console.log(err)
              })
    },
    getNews () {
      let data = {
        user_id:this.$store.state.user_id,
      };
      this.$post(newsData,data)
              .then(res => {
                let data = res.data;
                this.is_new = data.is_new;
              })
              .catch(err => {
                window.console.log(err)
              })
    },
    checkLogin () {
      if (!this.$store.state.code) {
        this.$router.push('/');
        this.$message.error('您还未登录，请登录');
      } else if (this.$store.state.user_type !== 0) {
        this.$router.push('/');
        this.$message.error('很抱歉，您不是企业用户，请注册认证！');
      } else if (this.$store.state.user_type === 0 && this.$store.state.is_auth !== 1) {
        this.$router.push('/');
        this.$message.error('很抱歉，您还不是认证企业，请认证！')
      }
    },
    showMobile () {
        this.isShowMobile = true;
    },
      showMobileA () {
          this.isShowMobileA = true;
      },
    close () {
      this.isShowMobile = false;
      this.isShowMobileA = false;
    },
      showMoneyClick () {
        this.showMoney = !this.showMoney
      }
  },
  computed: {
    mobileContent() {
      return this.$store.state.mobileCon;
    },
    mobileImageCon () {
      return this.$store.state.previewImage;
    },
    mobileTitle() {
      return this.$store.state.mobileTit;
    }
  },
  watch: {
    mobileContent (newCount) {
      this.mobileCon = newCount;
    },
    mobileImageCon (newCount) {
      this.mobileImage = newCount;
    },
    mobileTitle (newCount) {
      this.mobileTit = newCount;
    },
    // "$route": "getNews"
  },
  mounted() {
    this.getEpInfo();
    this.checkLogin();
    this.getNews()
  },
  filters: {
    formatDate(time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate(date, 'yyyy-MM-dd')
      }
  }
}
</script>
<style scoped>
</style>
